/* src/app/modules/taxes/quarterly-tax-receipt/quarterly-tax-receipt-dialog-delete.component.css */
.dlg-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
}
.dlg-hdr__title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dlg-hdr__icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, .12);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dlg-hdr__icon-wrap mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #4d7a00;
}
.dlg-hdr__title > div > span {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
}
.dlg-hdr__sub {
  display: block;
  font-size: 12px;
  color: #6b7280;
}
.dlg-hdr__close {
  color: #6b7280;
}
.dlg-body {
  padding: 24px 24px 8px !important;
}
.dlg-body p {
  margin: 0 0 4px;
  font-size: 14px;
  color: #1a1d23;
}
.dlg-actions {
  padding: 12px 20px !important;
  border-top: 1px solid #e5e7eb;
  gap: 8px;
}
.dlg-btn-save {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, .85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
/*# sourceMappingURL=quarterly-tax-receipt-dialog-delete.component.css.map */
